import qs from 'qs';

const generateEndpoint = ({ host, params }) => {
  const queryString = qs.stringify(params, { arrayFormat: 'brackets' });
  return queryString ? `${host}?${queryString}` : host;
};

export { generateEndpoint };
